import { InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import moment from "moment";
import { Fragment } from "react";
import { formatCurrency } from "../../../../../utils/formatCurrency";
import { ChannelRatesManagement } from "../channelRatesManagement";
import { MaxStayManagement } from "../maxStayManagement";
import { MinStayManagement } from "../minStayManagement";

export const RatePlansManagement = (props) => {
  const {
    ratePlans,
    dateColumns,
    currentMonth,
    selectedYear,
    rentPerDayByDate,
    handleCellClick,
    roomId,
    closeout,
    rentperday,
    showRestrictions,
    minimumStay,
    maximumStay,
    mappingsByRoomAndPlan,
    onRefetchMappings,
  } = props;

  return (
    <Fragment>
      {ratePlans[roomId]?.map((plan) => (
        <Fragment>
          <tr key={plan._id}>
            <td className="sticky-column">
              {plan.rateplanname}
              {plan.ratePlanSetup === "Derived" && (
                <Tooltip
                  title={
                    <span
                      style={{
                        color: "#fff",
                        fontWeight: "bold",
                        fontSize: 14,
                      }}
                    >
                      Discount {plan.discount ? `${plan.discount}%` : "0%"}{" "}
                      applied for this Derived Rate Plan.
                    </span>
                  }
                  placement="top"
                >
                  <InfoCircleOutlined
                    tabIndex={0}
                    role="button"
                    aria-label="Derived Rate Plan Discount Info"
                    style={{
                      fontSize: 18,
                      color: "#666",
                      cursor: "pointer",
                      marginLeft: 8,
                    }}
                  />
                </Tooltip>
              )}
            </td>
            {dateColumns.map((date) => {
              const day = moment(date, "DD MMM").date();
              const dateKey = moment(
                `${day}-${currentMonth.month() + 1}-${selectedYear}`,
                "DD-MM-YYYY"
              ).format("DD-MM-YYYY");
              let rateForDate = 0;

              if (plan.ratePlanSetup === "Derived") {
                const baseRate =
                  rentPerDayByDate[roomId][dateKey] || rentperday;
                // apply ratePlan level discount if provided (expects discountPercentage on ratePlan)
                const discountPercentage = Number(plan.discount || 0);
                rateForDate = baseRate * (1 - discountPercentage / 100);
              } else if (plan.ratePlanSetup === "Manual") {
                rateForDate =
                  plan.rateplanpricing.find(
                    (rpp) => rpp.roomId.toString() === roomId
                  )?.manualRate[dateKey] || "";
              }
              const rawCloseout = closeout?.[roomId]?.[dateKey];
              const isClosedOut =
                rawCloseout &&
                (!!rawCloseout.all ||
                  (Array.isArray(rawCloseout.ratePlans) &&
                    rawCloseout.ratePlans.includes(plan._id)));

              return (
                <td
                  key={`${roomId}-${date}-rateplan-${plan._id}`}
                  className={`availability-cell ${
                    plan.ratePlanSetup === "Derived" ? "derived-rate" : ""
                  }`}
                  onClick={() =>
                    handleCellClick(roomId, dateKey, plan._id, "rate")
                  }
                  style={{
                    cursor: isClosedOut ? "not-allowed" : "pointer",
                    backgroundColor: isClosedOut ? "#f4e736" : "transparent",
                    pointerEvents: isClosedOut ? "none" : "auto",
                    opacity: isClosedOut ? 0.6 : 1,
                  }}
                >
                  <div>
                    {rateForDate ? formatCurrency(rateForDate) : "N/A"}
                    {plan.ratePlanSetup === "Derived" && (
                      <span className="link-symbol">🔗</span>
                    )}
                  </div>
                </td>
              );
            })}
          </tr>

          <ChannelRatesManagement
            mappings={mappingsByRoomAndPlan?.[roomId]?.[plan._id]}
            dateColumns={dateColumns}
            currentMonth={currentMonth}
            selectedYear={selectedYear}
            plan={plan}
            rentPerDayByDate={rentPerDayByDate}
            rentperday={rentperday}
            roomId={roomId}
            onRefetchMappings={onRefetchMappings}
          />

          {showRestrictions && (
            <MinStayManagement
              dateColumns={dateColumns}
              currentMonth={currentMonth}
              selectedYear={selectedYear}
              minimumStay={minimumStay}
              handleCellClick={handleCellClick}
              roomId={roomId}
              ratePlanId={plan._id}
              closeout={closeout}
            />
          )}

          {showRestrictions && (
            <MaxStayManagement
              dateColumns={dateColumns}
              currentMonth={currentMonth}
              selectedYear={selectedYear}
              maximumStay={maximumStay}
              handleCellClick={handleCellClick}
              roomId={roomId}
              ratePlanId={plan._id}
              closeout={closeout}
            />
          )}
        </Fragment>
      ))}
    </Fragment>
  );
};
